import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import RoznicaCITRZiSHeader from './RoznicaCITRZiSHeader'
import RoznicaCITRZiSList from './RoznicaCITRZiSList'
import styled from 'styled-components'

const InformacjaDodatkowaPodatekDochodowyStyle = styled.div`
  background-color: ${props => (props.shortenedView ? '#f5f5f5' : '#efefef')};
  .ExpansionPanelSummary {
    background: ${props => props.theme.black4};
    padding: 0 12px;

    > div:first-child {
      margin: 9px 0;
    }
  }
  padding-bottom: 16px;
  height: ${props => (props.shortenedView ? 'auto' : '90vh')};

  .container {
    justify-self: auto;
  }
`

class InformacjaDodatkowaPodatekDochodowy extends Component {
  state = {
    isExpanded: this.initExpanded() || this.initDetailsVisible(),
    isDetailsVisible: this.initDetailsVisible(),
  }

  initExpanded() {
    return this.props.data.Pozycje.some(
      item => item.KwotaRB_Kapitalowe || item.KwotaRP_Kapitalowe,
    ) || localStorage.getItem("infoDodatkExpanded") === 'true'
  }

  initDetailsVisible() {
    return this.props.data.Pozycje.some(
      item => item.PozycjeUzytkownika && item.PozycjeUzytkownika.length !== 0,
    ) || localStorage.getItem("infoDodatkDetails") === 'true'
  }

  expand = () => {
    this.setState({ isExpanded: !this.state.isExpanded })
    localStorage.setItem("infoDodatkExpanded", (!this.state.isExpanded).toString())
    if(!this.state.isExpanded === false)
      localStorage.setItem("infoDodatkDetails", 'false')
  }

  changeDetailsVisibility = () => {
    this.setState({ isDetailsVisible: !this.state.isDetailsVisible })
    localStorage.setItem("infoDodatkDetails", (!this.state.isDetailsVisible).toString())
  }

  render() {
    const {
      data,
      aktualizujSumy,
      czyKwotyWTysiacach,
      shortenedView,
      onSetSectionDataArray,
    } = this.props
    return (
      <InformacjaDodatkowaPodatekDochodowyStyle shortenedView={shortenedView}>
        <div className="header-text">
          {!shortenedView && (
            <div>INFORMACJA DODATKOWA DOTYCZĄCA PODATKU DOCHODOWEGO</div>
          )}
          <FormControlLabel
            control={
              <Checkbox
                name="Expand"
                color="primary"
                checked={this.state.isExpanded}
                onChange={this.expand}
              />
            }
            label="Włącz widok uwzględniający podział na przychody / koszty z zysków kapitałowych oraz z innych źródeł przychodu"
          />
          {this.state.isExpanded && (
            <FormControlLabel
              className="checkboxLabel"
              control={
                <Checkbox
                  name="ExpandDetail"
                  color="primary"
                  checked={this.state.isDetailsVisible}
                  onChange={this.changeDetailsVisibility}
                />
              }
              label="Włącz widok pozwalający dodać pozycje uszczegóławiąjące z podstawą prawną"
            />
          )}
        </div>
        <>
          <RoznicaCITRZiSHeader
            handleToggle={this.expand}
            shortenedView={shortenedView}
          />
          <div className="roznica-container">
            <RoznicaCITRZiSList
              isExpanded={this.state.isExpanded}
              isDetailsVisible={this.state.isDetailsVisible}
              dane={data.Pozycje}
              aktualizujSumy={aktualizujSumy}
              onSetSectionDataArray={onSetSectionDataArray}
              czyKwotyWTysiacach={czyKwotyWTysiacach}
            />
          </div>
        </>
      </InformacjaDodatkowaPodatekDochodowyStyle>
    )
  }
}

export default InformacjaDodatkowaPodatekDochodowy
